import { useContext } from 'react';
import { QuoteContext } from '@folio/modules/shared-quote/QuoteContext';
import { parseWakamError } from '@folio/utils/parseWakamError';
import { WakamErrorBanner } from './WakamErrorBanner';

export function WakamQuoteFunnelError() {
  const { calculatedQuotes } = useContext(QuoteContext);

  const errorDetails = calculatedQuotes.find(quote => quote.error)?.error?.details as
    | { quoteErrors?: { error?: string }[]; failedReason?: string; errorMessage?: string }
    | undefined;

  const rawError =
    errorDetails?.quoteErrors?.[0]?.error ??
    errorDetails?.failedReason ??
    errorDetails?.errorMessage;

  const errorMessage = parseWakamError(rawError);

  return <WakamErrorBanner errorMessage={errorMessage} />;
}
